const R = (e, r) => {
  const s = [];
  return e.forEach((n) => {
    r.forEach((t) => {
      s.push(`${t}:${n}`);
    });
  }), s;
};
function F(e) {
  return e.replace(/\/\*[\s\S]*?\*\/|\/\/.*/g, "").replace(/\s+/g, " ").trim();
}
function f(e) {
  return Array.isArray(e) ? e.map((r) => F(r)).join(" ") : F(e);
}
function q(e) {
  Object.entries(e).forEach(([r, s]) => {
    Object.entries(s).forEach(([n, t]) => {
      if (Array.isArray(t)) {
        const o = [];
        t.forEach((c) => {
          o.push(f(c));
        }), e[r][n] = o;
      } else typeof t == "string" ? e[r][n] = f(t) : typeof t == "object" ? Object.entries(t).forEach(([o, c]) => {
        if (Array.isArray(c)) {
          const a = [];
          c.forEach((h) => {
            a.push(f(h));
          }), e[r][n][o] = a;
        } else
          e[r][n][o] = f(c);
      }) : console.log("type missmatch on safeList");
    });
  });
}
function z(e) {
  return e.map((r) => {
    const { conditions: s, class: n } = r;
    if (Array.isArray(n)) {
      const t = [];
      return n.forEach((o) => {
        t.push(f(o));
      }), { conditions: s, class: t };
    } else {
      if (typeof n == "string")
        return { conditions: s, class: f(n) };
      if (typeof n == "object") {
        const t = {};
        return Object.entries(n).forEach(([o, c]) => {
          if (Array.isArray(c)) {
            const a = [];
            c.forEach((h) => {
              a.push(f(h));
            }), t[o] = a;
          } else
            t[o] = f(c);
        }), { conditions: s, class: t };
      } else
        console.log("type missmatch on safeList");
    }
  });
}
function J(e, r) {
  Object.entries(e).forEach(([s, n]) => {
    Array.isArray(n) ? n.forEach((t) => {
      t.split(" ").forEach((c) => r.add(c));
    }) : typeof n == "string" ? n.split(" ").forEach((o) => {
      r.add(o);
    }) : typeof n == "object" ? Object.entries(n).forEach(([t, o]) => {
      Array.isArray(o) ? o.forEach((c) => {
        c.split(" ").forEach((h) => r.add(h));
      }) : o.split(" ").forEach((a) => {
        r.add(a);
      });
    }) : console.log("type missmatch on safeList");
  });
}
function T(e, r) {
  const s = e.class;
  Array.isArray(s) ? s.forEach((n) => {
    n.split(" ").forEach((o) => r.add(o));
  }) : typeof s == "string" ? s.split(" ").forEach((t) => {
    r.add(t);
  }) : typeof s == "object" ? Object.entries(s).forEach(([n, t]) => {
    Array.isArray(t) ? t.forEach((o) => {
      o.split(" ").forEach((a) => r.add(a));
    }) : t.split(" ").forEach((c) => {
      r.add(c);
    });
  }) : console.log("type missmatch on safeList for variants");
}
const H = function(e) {
  const r = /* @__PURE__ */ new Set();
  let s = [];
  return e.length > 0 && (s = e[0].definition().screens), e.forEach(({ definition: n }) => {
    const t = n();
    if (q(t.variants), t.compoundVariants = z(
      t.compoundVariants
    ), t.responsiveVariants && t.responsiveVariants.length > 0) {
      const o = t.compoundVariants || [];
      t.responsiveVariants.forEach((c) => {
        J(
          t.variants[c],
          r
        ), o.filter((h) => typeof h.conditions[c] < "u").forEach((h) => {
          T(h, r);
        });
      });
    }
  }), r.size === 0 ? [] : R(Array.from(r), s);
}, D = (e) => [...new Set(e.filter(Boolean))].join(" "), _ = (e, r) => {
  if (typeof e == "string") return [e];
  if (Array.isArray(e)) return e;
  if (typeof e == "object" && e !== null) {
    const s = e[r];
    if (typeof s == "string") return [s];
    if (Array.isArray(s)) return s;
  }
  return [];
}, I = (e, r = (s) => s) => ({
  slots: s,
  variants: n,
  compoundVariants: t,
  responsiveVariants: o,
  defaultVariants: c
}) => {
  const a = /* @__PURE__ */ new Map();
  n && Object.entries(n).forEach(([C, g]) => {
    const E = /* @__PURE__ */ new Map();
    Object.entries(g).forEach(([O, S]) => {
      const l = /* @__PURE__ */ new Map();
      Object.keys(s).forEach((V) => {
        const p = _(
          S,
          V
        );
        l.set(V, new Set(p));
      }), E.set(O, l);
    }), a.set(C, E);
  });
  const h = (t == null ? void 0 : t.map((C) => ({
    conditions: C.conditions,
    classes: new Map(
      Object.entries(s).map(([g, E]) => [
        g,
        new Set(_(C.class, g))
      ])
    )
  }))) || [], M = /* @__PURE__ */ new Map();
  return () => ({
    ...Object.entries(s).reduce(
      (g, [E, O]) => (g[E] = (S) => {
        const l = {};
        S && Object.keys(S).forEach((i) => {
          S[i] !== void 0 && (l[i] = S[i]);
        });
        const V = JSON.stringify({ slot: E, props: l });
        if (M.has(V))
          return M.get(V) || "";
        const p = /* @__PURE__ */ new Set();
        typeof O == "string" ? p.add(f(O)) : Array.isArray(O) && O.forEach((i) => p.add(f(i)));
        const $ = { ...c, ...l }, x = /* @__PURE__ */ new Set(["initial"]);
        Object.values($).forEach((i) => {
          typeof i == "object" && i !== null && Object.keys(i).forEach((u) => x.add(u));
        }), Object.entries($).forEach(([i, u]) => {
          var j, w;
          if (i !== "className" && i !== "class" && a.has(i))
            if (typeof u == "object" && u !== null)
              Object.entries(u).forEach(
                ([y, m]) => {
                  var d, b;
                  const A = (b = (d = a.get(i)) == null ? void 0 : d.get(m)) == null ? void 0 : b.get(E);
                  A && A.forEach((N) => {
                    y === "initial" ? p.add(f(N)) : f(N).split(" ").forEach((B) => {
                      p.add(`${y}:${B}`);
                    });
                  });
                }
              );
            else {
              const y = (w = (j = a.get(i)) == null ? void 0 : j.get(u)) == null ? void 0 : w.get(E);
              y && y.forEach((m) => p.add(m));
            }
        }), h.forEach(({ conditions: i, classes: u }) => {
          x.forEach((j) => {
            var y;
            let w = !0;
            Object.entries(i).forEach(([m, A]) => {
              const d = $[m];
              let b;
              typeof d == "object" && d !== null ? b = j === "initial" ? d.initial : d[j] || d.initial : b = d, w = w && (Array.isArray(A) ? A.includes(
                b
              ) : A === b);
            }), w && ((y = u.get(E)) == null || y.forEach((m) => {
              j === "initial" ? p.add(f(m)) : f(m).split(" ").forEach((d) => {
                p.add(`${j}:${d}`);
              });
            }));
          });
        }), l != null && l.className && f(l.className).split(" ").forEach((i) => p.add(i)), l != null && l.class && f(l.class).split(" ").forEach((i) => p.add(i));
        const L = r(D(Array.from(p)));
        return M.set(V, L), L;
      }, g),
      {}
    ),
    definition: () => ({
      slots: s,
      variants: n,
      compoundVariants: t || [],
      responsiveVariants: o,
      defaultVariants: c,
      screens: e
    })
  });
};
export {
  H as generateSafeList,
  I as setupCompose
};
